import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { modePatternsStyle } from './style';
import { makeCapitalize } from 'utils';
import { CustomNumericFormat } from '../../../../../components';

const WEEKDAYS = [
    { weekdayValue: 'Sun' },
    { weekdayValue: 'Mon' },
    { weekdayValue: 'Tue' },
    { weekdayValue: 'Wed' },
    { weekdayValue: 'Thu' },
    { weekdayValue: 'Fri' },
    { weekdayValue: 'Sat' },
];

export const WeeklyPattern = ({ inputs, handleChangeWeek, handleChangeWeeks }) => {
    const classes = modePatternsStyle();
    const datesAreNotMentioned = !inputs.startDate || !inputs.endDate;

    return (
        <div style={datesAreNotMentioned ? { opacity: '0.5' } : {}}>
            <div className={classes.patternBoxStyle} style={{ marginBottom: 10 }}>
                <span className={classes.weeks}>Recur every</span>
                <CustomNumericFormat
                    className={classes.smallInput}
                    name={'repeatCountWeek'}
                    value={inputs?.repeatCountWeek}
                    handleChangeMiles={(e) =>
                        handleChangeWeek({
                            target: {
                                name: 'repeatCountWeek',
                                value: e.floatValue,
                            },
                        })
                    }
                    noError={true}
                    disabled={datesAreNotMentioned}
                    decimalScale={0}
                />
                {/*<input*/}
                {/*   type={"number"}*/}
                {/*   value={inputs.repeatCountWeek || ""}*/}
                {/*   name={"repeatCountWeek"}*/}
                {/*   onChange={handleChangeWeek}*/}
                {/*   className={classes.smallInput}*/}
                {/*   disabled={datesAreNotMentioned}*/}
                {/*/>*/}
                <span className={classes.days}>week(s)</span>
            </div>
            <FormGroup className={classes.formGroup} onChange={handleChangeWeeks} name="weeks">
                {WEEKDAYS.map((weekday, index) => (
                    <FormControlLabel
                        style={{ margin: '0 10px 0 0' }}
                        key={index}
                        value={index}
                        control={<Checkbox style={{ padding: '3px 8px 3px 0' }} />}
                        name={makeCapitalize(weekday.weekdayValue)}
                        label={makeCapitalize(weekday.weekdayValue)}
                        disabled={datesAreNotMentioned}
                    />
                ))}
            </FormGroup>
        </div>
    );
};
